<template>
  <div class="wrapper" @click.stop>
    <div class="content">
      <div class="title">基本信息 {{ office }}</div>
      <div class="subtitle">个人信息</div>
      <div class="form">
        <div class="form__row">
          <div class="form__col">
            <div class="form__item">
              <div class="form__label required">姓：</div>
              <div class="form__value">
                <input v-model="form.firstName" type="text" />
              </div>
            </div>
          </div>
          <div class="form__col">
            <div class="form__item">
              <div class="form__label required">名：</div>
              <div class="form__value">
                <input v-model="form.lastName" type="text" />
              </div>
            </div>
          </div>
        </div>

        <div class="form__item">
          <div class="form__label required">英文名（偏好姓名）:</div>
          <div class="form__value">
            <input v-model="form.nickName" type="text" />
          </div>
        </div>

        <div class="form__row">
          <div class="form__col">
            <div class="form__item">
              <div class="form__label required">性別：</div>
              <div @click="sexPicker = true" class="form__value selector">
                <div class="form__value-input">
                  {{ form.sex }}
                </div>
              </div>
            </div>
          </div>
          <div class="form__col">
            <div class="form__item">
              <div class="form__label required">出生日期：</div>
              <div
                @click="dateOfBirthPicker = true"
                class="form__value selector"
              >
                <div class="form__value-input">
                  {{ form.dateOfBirth }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form__item">
          <div class="form__label required">国籍：</div>
          <div class="form__value">
            <div class="form__value-input disabled">
              {{ form.nationality }}
            </div>
          </div>
        </div>

        <div class="form__item">
          <div class="form__label required">联系地址 (当前居住地）：</div>
          <div class="form__value">
            <textarea v-model="form.currentAddress" type="text" />
          </div>
        </div>

        <div class="form__item" v-if="rules.politicalOutlook.show">
          <div
            :class="rules.politicalOutlook.required ? 'required' : ''"
            class="form__label"
          >
            政治面貌：
          </div>
          <div
            @click="politicalOutlookPicker = true"
            class="form__value selector"
          >
            <div class="form__value-input">
              {{ form.politicalOutlook }}
            </div>
          </div>
        </div>

        <div class="form__item">
          <div class="form__label required">婚姻状况：</div>
          <div @click="maritalStatusPicker = true" class="form__value selector">
            <div class="form__value-input">
              {{ form.maritalStatus }}
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>

      <div class="subtitle">银行信息</div>
      <div class="form">
        <div class="form__item">
          <div class="form__label required">银行名称：</div>
          <div @click="bankPicker = true" class="form__value selector">
            <div class="form__value-input">
              {{ form.bankName }}
            </div>
            <!-- <input v-model="form.bankName" selector type="text" /> -->
          </div>
        </div>
        <div class="form__item">
          <div class="form__label required">支行名称：</div>
          <div class="form__value">
            <input
              v-model="form.bankBranch"
              placeholder="For HK office please enter Branch Code instead"
              type="text"
            />
          </div>
        </div>

        <template v-if="rules.bankCode.show">
          <div class="form__item">
            <div
              :class="rules.bankCode.required ? 'required' : ''"
              class="form__label"
            >
              支行代码（Branch Code) ：
            </div>
            <div class="form__value">
              <input v-model="form.bankCode" type="text" />
            </div>
          </div>
        </template>

        <!--<div class="form__item">
          <div class="form__label required">账号类别：</div>
          <div @click="accountTypePicker = true" class="form__value selector">
            <div class="form__value-input">
              {{ form.accountType }}
            </div>
          </div>
        </div>-->
        <div class="form__item">
          <div class="form__label required">银行卡账号：</div>
          <div class="form__value">
            <input v-model="form.bankCardAccount" type="text" />
          </div>
        </div>
        <div class="form__item">
          <div class="form__label required">账号姓名：</div>
          <div class="form__value">
            <input v-model="form.accountName" type="text" />
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="subtitle">联系信息</div>
      <div class="form">
        <div class="form__item">
          <div class="form__label required">紧急联系人姓名：</div>
          <div class="form__value">
            <input v-model="form.contactsName" type="text" />
          </div>
        </div>
        <div class="form__item">
          <div class="form__label required">联系人与本人关系：</div>
          <div @click="relationshipPicker = true" class="form__value selector">
            <div class="form__value-input">
              {{ form.relationship }}
            </div>
          </div>
        </div>
        <div class="form__item">
          <div class="form__label required">联系人电话：</div>
          <div class="form__value">
            <input v-model="form.contactPhone" type="text" />
          </div>
        </div>
        <div class="form__item">
          <div class="form__label">联系人邮箱：</div>
          <div class="form__value">
            <input v-model="form.contactEmail" type="text" />
          </div>
        </div>
      </div>
      <template v-if="office === '中国大陆'">
        <div class="line"></div>
        <div class="subtitle">其他信息</div>
        <div class="form">
          <div class="form__item">
            <div class="form__label required">
              入职当月是否需要公司给缴纳社保公积金？
            </div>
            <div
              @click="isSocialSecurityPicker = true"
              class="form__value selector"
            >
              <div class="form__value-input">
                {{ form.isSocialSecurity }}
              </div>
            </div>
          </div>
          <div class="form__item">
            <div class="form__label">
              工作所在城市的住房公积金账号（如果有）：
            </div>
            <div class="form__value">
              <input v-model="form.accumulationFundCode" type="text" />
            </div>
          </div>
          <div class="form__item">
            <div class="form__label">首次参加社会工作年月：</div>
            <div
              @click="firstSocialWorkPicker = true"
              class="form__value selector"
            >
              <div class="form__value-input">
                {{ form.firstSocialWork }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="card-content">
        <div class="title">证件信息</div>
        <div class="form">
          <div class="form__item">
            <div class="form__label required">有效证件类型：</div>
            <!-- @click="governmentIdTypePicker = true" -->
            <div class="form__value">
              <div class="form__value-input disabled">
                {{ form.governmentIdType }}
              </div>
            </div>
          </div>

          <div class="form__item">
            <div class="form__label required">证件号：</div>

            <div class="form__value crad">
              <input v-model="form.identificationNumber" type="text" />
            </div>
          </div>

          <div class="form__item" v-if="rules.residentType.show">
            <div
              :class="rules.residentType.required ? 'required' : ''"
              class="form__label"
            >
              户口类型：
            </div>
            <div
              @click="residentTypePicker = true"
              class="form__value crad selector"
            >
              <div class="form__value-input">
                {{ form.residentType }}
              </div>
            </div>
          </div>
          <div class="form__item" v-if="rules.residentLocation.show">
            <div
              :class="rules.residentLocation.required ? 'required' : ''"
              class="form__label"
            >
              户口所在地：
            </div>
            <div class="form__value crad">
              <input
                placeholder="XX省XX市XX区XX街道XX号"
                v-model="form.residentLocation"
                type="text"
              />
            </div>
          </div>

          <div class="form__item" v-if="rules.passportNo.show">
            <div
              :class="rules.passportNo.required ? 'required' : ''"
              class="form__label"
            >
              Passport No.：
            </div>
            <div class="form__value crad">
              <input v-model="form.passportNo" type="text" />
            </div>
          </div>
          <div class="form__item" v-if="rules.passportIssueCountry.show">
            <div
              :class="rules.passportIssueCountry.required ? 'required' : ''"
              class="form__label"
            >
              护照签发国家地区 （Passport Country of Issue）
            </div>
            <div class="form__value crad">
              <input v-model="form.passportIssueCountry" type="text" />
            </div>
          </div>
          <div class="form__item" v-if="rules.spousesName.show">
            <div
              :class="rules.spousesName.required ? 'required' : ''"
              class="form__label"
            >
              Spouse’s Name：
            </div>
            <div class="form__value crad">
              <input v-model="form.spousesName" type="text" />
            </div>
          </div>
          <div class="form__item" v-if="rules.hongkongIdentityCard.show">
            <div
              :class="rules.hongkongIdentityCard.required ? 'required' : ''"
              class="form__label"
            >
              Spouse's HKID Card No.：
            </div>
            <div class="form__value crad">
              <input v-model="form.hongkongIdentityCard" type="text" />
            </div>
          </div>
          <div class="form__item" v-if="rules.spousesPassportNumber.show">
            <div
              :class="rules.spousesPassportNumber.required ? 'required' : ''"
              class="form__label"
            >
              Spouse's Passport No.：
            </div>
            <div class="form__value crad">
              <input v-model="form.spousesPassportNumber" type="text" />
            </div>
          </div>
          <div class="form__item" v-if="rules.spousesPassportIssueCountry.show">
            <div
              :class="
                rules.spousesPassportIssueCountry.required ? 'required' : ''
              "
              class="form__label"
            >
              Spouse's Passport Country of Issue：
            </div>
            <div class="form__value crad">
              <input v-model="form.spousesPassportIssueCountry" type="text" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div @click.stop="handleNext" class="next">继续</div>
      <div @click.stop="handleSkip" class="skip">稍后完成</div>
    </div>

    <van-popup v-model="dateOfBirthPicker" position="bottom">
      <van-datetime-picker
        v-model="dateOfBirthPickerDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handleDateOfBirthPickerConfirm"
        @cancel="dateOfBirthPicker = false"
      />
    </van-popup>

    <van-popup v-model="firstSocialWorkPicker" position="bottom">
      <van-datetime-picker
        v-model="firstSocialWorkPickerDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handleFirstSocialWorkPickerConfirm"
        @cancel="firstSocialWorkPicker = false"
      />
    </van-popup>

    <van-popup v-model="sexPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="sexPickerColumns"
        @confirm="handleSexPickerConfirm"
        @cancel="sexPicker = false"
      />
    </van-popup>

    <van-popup v-model="maritalStatusPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="maritalStatusPickerColumns"
        @confirm="handleMaritalStatusPickerConfirm"
        @cancel="maritalStatusPicker = false"
      />
    </van-popup>

    <van-popup v-model="residentTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="residentTypePickerColumns"
        @confirm="handleResidentTypePickerConfirm"
        @cancel="residentTypePicker = false"
      />
    </van-popup>

    <van-popup v-model="isSocialSecurityPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="isSocialSecurityPickerColumns"
        @confirm="handleIsSocialSecurityPickerConfirm"
        @cancel="isSocialSecurityPicker = false"
      />
    </van-popup>

    <van-popup v-model="accountTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="accountTypePickerColumns"
        @confirm="handleAccountTypePickerConfirm"
        @cancel="accountTypePicker = false"
      />
    </van-popup>

    <van-popup v-model="politicalOutlookPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="politicalOutlookPickerColumns"
        @confirm="handlePoliticalOutlookPickerConfirm"
        @cancel="politicalOutlookPicker = false"
      />
    </van-popup>

    <van-popup v-model="governmentIdTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="governmentIdTypePickerColumns"
        @confirm="handleGovernmentIdTypePickerConfirm"
        @cancel="governmentIdTypePicker = false"
      />
    </van-popup>

    <van-popup v-model="nationalityPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="nationalityIndex"
        :columns="nationalityPickerColumns"
        @confirm="handleNationalityPickerConfirm"
        @cancel="nationalityPicker = false"
      />
    </van-popup>

    <van-popup v-model="bankPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="bankPickerColumns"
        @confirm="handleBankPickerConfirm"
        @cancel="bankPicker = false"
      />
    </van-popup>

    <van-popup v-model="relationshipPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="relationshipColumns"
        @confirm="relationshipPickerConfirm"
        @cancel="relationshipPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Overlay, DatetimePicker, Popup, Picker } from 'vant';
import { mapGetters } from 'vuex';
const dayjs = require('dayjs');
import { cloneDeep } from 'lodash';
import { getOffice } from '../utils';

export default {
  name: 'perfectInfoDialog',

  components: {
    [Overlay.name]: Overlay,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },

  data() {
    return {
      show: true,

      dateOfBirthPicker: false,
      dateOfBirthPickerDate: new Date(1993, 0, 1),
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2050, 10, 1),

      firstSocialWorkPicker: false,
      firstSocialWorkPickerDate: new Date(1993, 0, 1),

      maritalStatusPicker: false,
      maritalStatusPickerColumns: ['已婚', '未婚', '分居', '离异', '丧偶'],

      residentTypePicker: false,
      residentTypePickerColumns: ['城镇', '农村'],

      isSocialSecurityPicker: false,
      isSocialSecurityPickerColumns: ['是', '否'],

      sexPicker: false,
      sexPickerColumns: ['Male', 'Female'],

      accountTypePicker: false,
      accountTypePickerColumns: ['储蓄卡', '类型2'],

      politicalOutlookPicker: false,
      politicalOutlookPickerColumns: ['中共党员', '致公党党员', '民革会员', '无党派民主人士',
      '民进会员', '中共预备党员', '九三学社社员', '民盟盟员', '群众', '农工党党员', '共青团员',
      '台盟盟员', '民建会员'],

      nationalityPicker: false,
      nationalityIndex: 0,
      nationalityPickerColumns: ['中国大陆', '香港', '台湾', '澳门', '外籍'],

      governmentIdTypePicker: false,

      relationshipPicker: false,
      relationshipColumns: ['父亲', '母亲', '配偶', '子女', '其他'],

      bankPicker: false,
      bankPickerColumns: [],
      bankList: [],


      rules: {
        // -------- 个人信息 start
        firstName: {
          required: true,
          show: true,
          msg: '请填写姓',
        },
        lastName: {
          required: true,
          show: true,
          msg: '请填写名',
        },
        nickName: {
          required: true,
          show: true,
          msg: '请填写英文名（偏好姓名）',
        },
        sex: {
          required: true,
          show: true,
          msg: '请选择性别',
        },
        dateOfBirth: {
          required: true,
          show: true,
          msg: '请选择生日',
        },
        nationality: {
          required: true,
          show: true,
          msg: '选填写国籍',
        },
        currentAddress: {
          required: true,
          show: true,
          msg: '选填写联系地址 (当前居住地）',
        },
        politicalOutlook: {
          required: true,
          show: true,
          msg: '请选择政治面貌',
        },
        maritalStatus: {
          required: true,
          show: true,
          msg: '请选择婚姻状况',
        },
        // -------- 个人信息 end

        // -------- 银行信息 start
        bankName: {
          required: true,
          show: true,
          msg: '请填写银行名称',
        },
        bankBranch: {
          required: true,
          show: true,
          msg: '请填写支行名称',
        },
        bankCode: {
          required: true,
          show: true,
          msg: '请填写支行代码',
        },
        // accountType: {
        //   required: true,
        //   show: true,
        //   msg: "请填写账号类别",
        // },
        bankCardAccount: {
          required: true,
          show: true,
          msg: '请填写银行卡账号',
        },
        accountName: {
          required: true,
          show: true,
          msg: '请填写账号姓名',
        },
        // -------- 银行信息 end

        // -------- 联系信息 start
        contactsName: {
          required: true,
          show: true,
          msg: '请填写紧急联系人',
        },
        relationship: {
          required: true,
          show: true,
          msg: '请填写联系人与本人关系',
        },
        contactPhone: {
          required: true,
          show: true,
          msg: '请填写联系人电话',
        },
        contactEmail: {
          required: false,
          show: true,
          msg: '请填写联系人邮箱',
        },
        // -------- 联系信息 end

        // -------- 其他信息 start
        isSocialSecurity: {
          required: true,
          show: true,
          msg: '请选择入职当月是否需要公司给缴纳社保公积金',
        },
        accumulationFundCode: {
          required: false,
          show: true,
          msg: '请填写工作所在城市的住房公积金账号',
        },
        firstSocialWork: {
          required: true,
          show: true,
          msg: '请填写入职当月是否需要公司给缴纳社保公积金',
        },
        // -------- 其他信息 end

        // -------- 证件信息 start
        governmentIdType: {
          required: false,
          show: true,
          msg: '请选择有效证件类型',
        },
        identificationNumber: {
          required: false,
          show: true,
          msg: '请填写证件号',
        },
        residentType: {
          required: true,
          show: true,
          msg: '请选择户口类型',
        },
        residentLocation: {
          required: true,
          show: true,
          msg: '请填写户口所在地',
        },
        passportIssueCountry: {
          show: true,
          required: false,
          msg: '请填写护照签发国家地区',
        },
        spousesName: {
          show: true,
          required: false,
          msg: "请填写Spouse's Name",
        },
        hongkongIdentityCard: {
          required: false,
          show: true,
          msg: "请填写Spouse's HKID Card No.",
        },
        spousesPassportNumber: {
          required: false,
          show: true,
          msg: "请填写Spouse's Passport No.",
        },
        spousesPassportIssueCountry: {
          required: false,
          show: true,
          msg: "请填写Spouse's Passport Country of Issue.",
        },
        passportNo: {
          show: true,
          required: false,
          msg: '请填写Passport No.',
        },
        // -------- 证件信息 end
      },

      form: {
        firstName: '',
        lastName: '',
        nickName: '',
        sex: '',
        dateOfBirth: '',
        nationality: '',
        currentAddress: '',
        politicalOutlook: '',
        maritalStatus: '',
        bankName: '',
        bankBranch: '',
        bankCode: '',
        // accountType: "",
        bankCardAccount: '',
        accountName: '',
        contactsName: '',
        relationship: '',
        contactPhone: '',
        contactEmail: '',
        governmentIdType: '',
        identificationNumber: '',
        passportIssueCountry: '',
        passportNo: '',
        spousesName: '',
        hongkongIdentityCard: '',
        spousesPassportNumber: '',
        spousesPassportIssueCountry: '',
        isSocialSecurity: '',
        accumulationFundCode: '',
        firstSocialWork: '',
        residentType: '',
        residentLocation: '',
      },
    };
  },

  computed: {
    ...mapGetters(['getUserInfo']),

    governmentIdTypePickerColumns() {
      if (this.office === '香港') {
        this.form.governmentIdType = 'HKID';
        return [this.form.governmentIdType];
      }

      if (this.nationality === '中国大陆' && this.office === '中国大陆') {
        this.form.governmentIdType = '中国大陆身份证';
        return [this.form.governmentIdType];
      }

      if (this.nationality === '香港' && this.office === '中国大陆') {
        this.form.governmentIdType = '港澳居民来往内地通行证';
        return [this.form.governmentIdType];
      }

      if (this.nationality === '澳门' && this.office === '中国大陆') {
        this.form.governmentIdType = '港澳居民来往内地通行证';
        return [this.form.governmentIdType];
      }

      if (this.nationality === '台湾' && this.office === '中国大陆') {
        this.form.governmentIdType = '台湾居民来往大陆通行证';
        return [this.form.governmentIdType];
      }

      if (this.nationality === '台湾' && this.office === '台湾') {
        this.form.governmentIdType = '台湾ID';
        return [this.form.governmentIdType];
      }

      if (!['中国大陆', '香港', '澳门', '台湾'].includes(this.nationality)) {
        this.form.governmentIdType = '护照 (Passport)';
        return [this.form.governmentIdType];
      }

      return [];
    },

    // 国籍
    nationality() {
      return this.form.nationality;
    },

    // 入职城市
    hireLication() {
      return this.getUserInfo().hireLication;
    },
    // 入职办公室
    office() {
      const { hireLication } = this;
      return getOffice(hireLication);
    },
  },

  watch: {
    office: {
      handler(val) {
        const isHongKong = val === '香港';
        const isDalu = val === '中国大陆';
        const isTaiWan = val === '台湾';

        this.rules.bankCode.required = isHongKong;
        this.rules.bankCode.show = isHongKong;

        this.rules.passportNo.required = isHongKong || isTaiWan;
        this.rules.passportNo.show = isHongKong || isTaiWan;

        this.rules.passportIssueCountry.required = isHongKong || isTaiWan;
        this.rules.passportIssueCountry.show = isHongKong || isTaiWan;

        this.rules.isSocialSecurity.required = isDalu;
        this.rules.isSocialSecurity.show = isDalu;

        this.rules.accumulationFundCode.show = isDalu;
        this.rules.accumulationFundCode.required = false;

        this.rules.firstSocialWork.show = isDalu;
        this.rules.firstSocialWork.required = false;
      },
      immediate: true,
    },
    nationality: {
      handler(val) {
        const isDalu = val === '中国大陆';
        const isOfficeDalu = this.office === '中国大陆';

        this.rules.politicalOutlook.required = isDalu && isOfficeDalu;
        this.rules.politicalOutlook.show = isDalu && isOfficeDalu;

        this.rules.residentType.required = isDalu && isOfficeDalu;
        this.rules.residentType.show = isDalu && isOfficeDalu;
        this.rules.residentLocation.required = isDalu && isOfficeDalu;
        this.rules.residentLocation.show = isDalu && isOfficeDalu;
      },
      immediate: true,
    },

    'form.maritalStatus': {
      handler(val) {
        const isHongKong = this.office === '香港';
        const married = ['已婚', '分居'].includes(val);
        this.rules.spousesName.required = married && isHongKong;
        this.rules.spousesName.show = isHongKong;
        this.rules.hongkongIdentityCard.required = married && isHongKong;
        this.rules.hongkongIdentityCard.show = isHongKong;
        this.rules.spousesPassportNumber.required = married && isHongKong;
        this.rules.spousesPassportNumber.show = isHongKong;
        this.rules.spousesPassportIssueCountry.required = married && isHongKong;
        this.rules.spousesPassportIssueCountry.show = isHongKong;
      },
      immediate: true,
    },
  },

  methods: {
    handleDateOfBirthPickerConfirm(e) {
      this.form.dateOfBirth = dayjs(e).format('YYYY-MM-DD');
      this.dateOfBirthPicker = false;
    },
    handleFirstSocialWorkPickerConfirm(e) {
      this.form.firstSocialWork = dayjs(e).format('YYYY-MM');
      this.firstSocialWorkPicker = false;
    },
    handleMaritalStatusPickerConfirm(e) {
      this.form.maritalStatus = e;
      this.maritalStatusPicker = false;
    },
    handleResidentTypePickerConfirm(e) {
      this.form.residentType = e;
      this.residentTypePicker = false;
    },
    handleIsSocialSecurityPickerConfirm(e) {
      this.form.isSocialSecurity = e;
      this.isSocialSecurityPicker = false;
    },

    handleNationalityPickerConfirm(e, index) {
      this.form.nationality = e;
      this.nationalityIndex = index;
      this.nationalityPicker = false;
    },

    handleSexPickerConfirm(e) {
      this.form.sex = e;
      this.sexPicker = false;
    },
    handleAccountTypePickerConfirm(e) {
      this.form.accountType = e;
      this.accountTypePicker = false;
    },
    relationshipPickerConfirm(e) {
      this.form.relationship = e;
      this.relationshipPicker = false;
    },
    handlePoliticalOutlookPickerConfirm(e) {
      this.form.politicalOutlook = e;
      this.politicalOutlookPicker = false;
    },
    handleGovernmentIdTypePickerConfirm(e) {
      this.form.governmentIdType = e;
      this.governmentIdTypePicker = false;
    },
    handleBankPickerConfirm(e) {
      this.form.bankName = e;
      this.bankPicker = false;
      const bankInfo = this.bankList.find(item => e === item.bankName)
      if (bankInfo) {
        console.log('bankInfo.bankCode :>> ', bankInfo.bankCode);
      }
    },
    validate(data) {
      let flg = true;
      Object.keys(data).forEach(key => {
        let value = data[key];
        let rule = this.rules[key];
        if (rule.required && !value) {
          flg = false;
          this.$toast(rule.msg);
        }
      });
      return flg;
    },

    cloneDeep(data) {
      const params = cloneDeep(data);
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (!value || value === 'undefined' || value === 'null') {
          delete params[key];
        }
      });
      console.log(params);
      return params;
    },

    handleNext() {
      const valid = this.validate(this.form);
      if (!valid) {
        return;
      }

      const data = this.cloneDeep(this.form);
      data.dateOfBirth = dayjs(data.dateOfBirth);

      this.$api
        .doPost('/customer/editCustomer', data)
        .then(r => {
          this.$emit('perfect-done');
          if (!r || r.code === '0000') {
            this.$store.commit('setUserInfo', data);
          }
        })
        .catch(() => {
          this.$router.push('/introduce?step=24');
        });
    },

    handleSkip() {
      const data = this.cloneDeep(this.form);
      data.dateOfBirth = dayjs(data.dateOfBirth);
      this.$api
        .doPost('/customer/editCustomer', data)
        .then(r => {
          this.$emit('perfect-done');
          if (!r || r.code === '0000') {
            this.$store.commit('setUserInfo', data);
          }
        })
        .catch(() => {
          this.$router.push('/introduce?step=24');
        });
    },

    initFormData() {
      const userInfo = this.getUserInfo();

      this.form.firstName = userInfo.firstName;
      this.form.lastName = userInfo.lastName;
      this.form.nickName = userInfo.nickName;
      this.form.sex = userInfo.sex;
      if (userInfo.dateOfBirth) {
        let birth = dayjs(userInfo.dateOfBirth).format('YYYY-MM-DD');
        this.form.dateOfBirth = birth === 'Invalid Date' ? '' : birth
      }
      if (userInfo.firstSocialWork) {
        this.form.firstSocialWork = dayjs(userInfo.firstSocialWork).format(
          'YYYY-MM'
        );
      }
      this.form.nationality = userInfo.nationality;
      this.form.currentAddress = userInfo.currentAddress;
      this.form.politicalOutlook = userInfo.politicalOutlook;
      this.form.maritalStatus = userInfo.maritalStatus;
      this.form.bankName = userInfo.bankName;
      this.form.bankBranch = userInfo.bankBranch;
      this.form.bankCode = userInfo.bankCode;
      // this.form.accountType = userInfo.accountType;
      this.form.bankCardAccount = userInfo.bankCardAccount;
      this.form.accountName = userInfo.accountName;
      this.form.contactsName = userInfo.contactsName;
      this.form.relationship = userInfo.relationship;
      this.form.contactPhone = userInfo.contactPhone;
      this.form.contactEmail = userInfo.contactEmail;
      this.form.passportNo = userInfo.passportNo;
      if (this.governmentIdTypePickerColumns[0]) {
        this.form.governmentIdType = this.governmentIdTypePickerColumns[0];
      } else {
        if (userInfo.governmentIdType) {
          this.form.governmentIdType = userInfo.governmentIdType;
        }
      }
      this.form.identificationNumber = userInfo.identificationNumber;
      this.form.passportIssueCountry = userInfo.passportIssueCountry;
      this.form.spousesName = userInfo.spousesName;
      this.form.hongkongIdentityCard = userInfo.hongkongIdentityCard;
      this.form.spousesPassportNumber = userInfo.spousesPassportNumber;
      this.form.spousesPassportIssueCountry =
        userInfo.spousesPassportIssueCountry;
      this.form.isSocialSecurity = userInfo.isSocialSecurity;
      this.form.accumulationFundCode = userInfo.accumulationFundCode;
      this.form.residentType = userInfo.residentType;
      this.form.residentLocation = userInfo.residentLocation;

      for (let prop in this.form) {
        if (this.form[prop] == 'undefined') {
          this.form[prop] = '';
        }
      }
    },

    getBankName() {
      this.$api
        .doPost('/customer/queryBankName')
        .then(r => {
          this.bankPickerColumns = r.map(item => item.bankName);
          this.bankList = r
        })
    }
  },

  created() {
    this.initFormData();
    this.getBankName();
    window.dialog = this;
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  color: #333;
  overflow: auto;
  background-color: #00000060;
  padding-top: 40px;
  .disabled {
    background-color: #dfdfdf !important;
  }
  .form {
    padding: 5px 27px;
    &__item {
      margin-top: 10px;
    }
    &__row {
      display: flex;
      justify-content: space-between;
    }
    &__col {
      width: 48%;
    }
    &__label {
      font-size: 13px;
      &.required {
        position: relative;
        &:after {
          content: '*';
          color: red;
        }
      }
    }
    &__value {
      position: relative;

      &.selector {
        $width: 15px;
        $height: $width;

        &:before {
          position: absolute;
          content: '';
          width: $width;
          height: $height;
          top: 50%;
          right: 10px;
          margin-top: -$height / 2;
          background-image: url(../assets/images/down.svg);
          background-size: 100% 100%;
        }
      }

      input {
        width: 100%;
        height: 26px;
        background: #ffffff;
        border: 1px solid #9e9e9e;
        border-radius: 13px;
        padding: 0 13px;
        box-sizing: border-box;
      }

      &-input {
        width: 100%;
        height: 26px;
        line-height: 26px;
        background: #ffffff;
        border: 1px solid #9e9e9e;
        border-radius: 13px;
        padding: 0 13px;
        box-sizing: border-box;
      }

      textarea {
        width: 100%;
        height: 56px;
        background: #ffffff;
        border: 1px solid #9e9e9e;
        border-radius: 13px;
        padding: 0 13px;
        box-sizing: border-box;
        box-sizing: border-box;
      }

      input[disabled] {
        background: #ffffff;
      }

      //&.crad {
      //  input {
      //    border: 0;
      //    background: #ececec;
      //  }
      //}
      &.crad-first {
        div {
          border: 0;
          background: #ffa32d;
        }
      }
    }
  }
  .line {
    margin: 30px auto;
    width: 279px;
    height: 3px;
    background: #553d40;
    opacity: 0.5;
  }
  .content {
    overflow: hidden;
    margin: 13px auto;
    width: 332px;
    background: #ffcc6b;
    border-radius: 15px;
    .title {
      font-size: 17px;
      font-weight: bold;
      margin-left: 27px;
      margin-top: 30px;
    }
    .subtitle {
      margin-top: 25px;
      text-align: right;
      padding-right: 12px;
      font-size: 15px;
      width: 92px;
      height: 25px;
      line-height: 25px;
      background: #cd742c;
      color: #fff;
      font-weight: bold;
      border-radius: 0px 12px 12px 0px;
    }

    .card-content {
      overflow: hidden;
      width: 332px;
      margin-top: 30px;
      padding-bottom: 30px;
      background: #ffbf46;
      box-shadow: 0px 0px 15px 0px rgba(170, 100, 0, 0.5);
      border-radius: 15px;
    }
  }
  .footer {
    margin-bottom: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    .next {
      margin: 0 10px;
      text-align: center;
      width: 121px;
      height: 38px;
      font-size: 15px;
      line-height: 38px;
      background: #ffffff;
      border: 1px solid #2b2b33;
      border-radius: 19px;
    }
    .skip {
      text-align: center;
      margin: 0 10px;
      width: 126px;
      height: 38px;
      line-height: 38px;
      background: #2b2b33;
      border: 1px solid #2b2b33;
      border-radius: 19px;
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
